import React from 'react';
import withIcon from '../utilities/withIcon';

const IconToggle = () => {
  return (
    <g>
      <path d="M5 13A5 5 0 0 1 5 3h6a5 5 0 0 1 .217 9.995L11 13H5zm2.43-8.5H5a3.5 3.5 0 0 0-.192 6.995L5 11.5l2.43.001A4.984 4.984 0 0 1 6 8c0-1.363.545-2.598 1.43-3.5z" />
    </g>
  );
};

export default withIcon(IconToggle);
